<template>
  <div>
    <Form
      page-title="Add a new Floor"
      buttonName="Submit"
      :branchId="branchId"
      :businessId="businessId"
      :isCreateMode="true"
      :isInList="isInList"
      @submit="submit"
      ref="FloorForm"
      :loading="loading"
    />
  </div>
</template>
<script>
import Form from "./Form";
import { createFloor } from "@/API/FloorsAPIs";
import { submitAndNotify } from "@/helpers/utils";

export default {
  name: "Create",
  props: ["isInList", "businessId", "branchId"],
  components: { Form },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async submit(formData) {
      const callback = () => {
        this.$refs.FloorForm.resetForm();
      };
      submitAndNotify(this, createFloor(formData), callback);
    }
  }
};
</script>
<style></style>
